import React from "react";
import Item from "./Item";
import styles from "./index.module.less";

class CommentItem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { data = [], type = "", replyComment } = this.props;

    return (
      <>
        {!!data.length &&
          data.map((vv, ii) => (
            <div className={styles["comment-box"]}>
              <Item data={vv} key={ii} type={type} replyComment={(re_id, value, item) => replyComment(re_id, value, item) }/>
            </div>
          ))}
      </>
    );
  }
}

export default CommentItem;
